module.exports = __webpack_public_path__ + "img/arrow-right-button.95e93e7e.svg";